/**
 * Integration Marketplace Demo — relative-time helpers for sync status.
 * THROWAWAY DEMO CODE (see ./README.md). Sync timestamps are stored relative to
 * the real wall clock so "Just synced" / "Last synced 1h ago" read correctly
 * whenever the demo runs.
 */

/** ISO timestamp `minutes` in the past (real wall clock). */
export function minutesAgoIso(minutes: number): string {
  return new Date(Date.now() - minutes * 60_000).toISOString();
}

/** Current wall-clock ISO timestamp ("just synced"). */
export function nowIso(): string {
  return new Date().toISOString();
}

/** Short relative phrase, e.g. "just now", "12m ago", "1h ago", "3d ago". */
export function timeAgo(iso?: string): string {
  if (!iso) return 'never';
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return 'recently';
  const min = Math.floor((Date.now() - t) / 60_000);
  if (min < 1) return 'just now';
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const d = Math.floor(hr / 24);
  return `${d}d ago`;
}

/** Sync-status phrase for a link/record, e.g. "Just synced" / "Last synced 1h ago". */
export function syncLabel(iso?: string): string {
  if (!iso) return 'Not synced';
  return timeAgo(iso) === 'just now'
    ? 'Just synced'
    : `Last synced ${timeAgo(iso)}`;
}
